import { Component, input, booleanAttribute } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'dhats-button',
  standalone: true,
  imports: [CommonModule, MatButtonModule],
  templateUrl: './button.component.html',
  styleUrl: './button.component.scss',
})
export class ButtonComponent {
  variant = input<'primary' | 'secondary' | 'ghost'>('primary');
  size = input<'xs' | 'sm' | 'md' | 'lg'>('md');
  disabled = input<boolean, unknown>(false, { transform: booleanAttribute });
  type = input<'button' | 'submit' | 'reset'>('button');
}

